export const url = "https://api.surveymonkey.net/v3/collectors/408041324/responses"
export const token = "AB0hW0pH61EBNFQBB9MjGb1qQ52kXrQiiq8oG-hCoVOmQuJHPyMbKQlNYn.eNJ7C5Vjs9WhJBqyuZygLIHq28mR-VkcUvQIi51VTn4O8Q6R-EY0HZtb0.rr2qD8FMBnA"
